import React from "react";

// base container for whole site content
function Container({ children }) {
  return (
    <div
      style={{
        maxWidth: 768,
        minHeight: "100vh",
        margin: "0 auto",
        paddingTop: "4rem", // gap for fixed tab bar
        paddingBottom: "4rem", // gap for fixed bottom navigation
        backgroundColor: "#f5f5f5",
      }}
    >
      {children}
    </div>
  );
}

export default Container;
